








































import Vue from "vue";
import Softway from "@/components/experience/Softway.vue";
import Thales from "@/components/experience/Thales.vue";

export default Vue.extend({
  name: "Experience",

  components: {
    Softway,
    Thales
  },

  data() {
    return {
      model: 0
    };
  }
});
